import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { NavComponent } from './shared/components/nav/nav';
import { UploadPanelComponent } from './shared/components/upload-panel/upload-panel';
import { UploadService } from './core/services/upload.service';
import { ThemeService } from './core/services/theme.service';
import { AuthService } from './core/services/auth.service';
import { CompanyUrlSyncService } from './core/services/company-url-sync.service';

@Component({
	selector: 'app-root',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [RouterOutlet, NavComponent, UploadPanelComponent, Toast, ConfirmDialog],
	templateUrl: './app.html',
	styleUrl: './app.scss',
})
export class AppComponent {
	private theme = inject(ThemeService);
	private auth = inject(AuthService);
	// Eagerly instantiate so its router subscription is live from app start.
	private companyUrlSync = inject(CompanyUrlSyncService);
	// Eager init so the beforeunload effect arms the moment uploads start.
	private uploadService = inject(UploadService);

	constructor() {
		// Companies load from AuthService once the session is restored.
		this.auth.restoreSession();
	}
}
